import { Component, Input, ElementRef, AfterViewInit } from '@angular/core';

declare const lucide: { createIcons?: (opts: { root: HTMLElement; attrs?: Record<string, unknown> }) => void };

@Component({
	selector: 'kt-lucide-icon',
	template: '<i [attr.data-lucide]="kebabCaseName"></i>',
	styles: [':host { display: inline-block; } :host svg { width: 100%; height: 100%; }']
})
export class LucideIconComponent implements AfterViewInit {
	@Input() name = '';
	@Input() size = 24;
	@Input() strokeWidth = 2;
	@Input() color = 'currentColor';

	get kebabCaseName(): string {
		return this.name
			.replace(/([a-z0-9])([A-Z])/g, '$1-$2')
			.replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
			.toLowerCase();
	}

	constructor(private el: ElementRef) {}

	ngAfterViewInit(): void {
		if (typeof lucide !== 'undefined' && lucide.createIcons) {
			setTimeout(() => {
				const iconElement = this.el.nativeElement.querySelector('i');
				if (iconElement) {
					if (this.size) {
						iconElement.style.width = this.size + 'px';
						iconElement.style.height = this.size + 'px';
					}
					lucide.createIcons({
						root: this.el.nativeElement,
						attrs: {
							width: this.size,
							height: this.size,
							'stroke-width': this.strokeWidth,
							stroke: this.color
						}
					});
				}
			}, 0);
		}
	}
}
